'use client';

import { useAtomValue } from 'jotai';
import Link from 'next/link';

import { formStateAtom } from '@core/Atoms/Pdp/FormState.atom';
import { searchParamsAtom } from '@core/Atoms/SearchParams/SearchParams.atom';
import { userIdAtom } from '@core/Atoms/User/UserId.atom';
import Button from '@gds/Button/Button';
import { trackCustomEvent } from '@tracking/Utils/TrackCustomEvent';

import { generateLandingPageBlockTracking } from './LandingPageBlock.tracking';

type LandingPageBlockCtaProps = {
  ctaText: string;
  ctaUrl: string;
  className: string;
};

export const LandingPageBlockCta = ({ ctaText, ctaUrl, className }: LandingPageBlockCtaProps) => {
  const userId = useAtomValue(userIdAtom);
  const searchParams = useAtomValue(searchParamsAtom);
  const formState = useAtomValue(formStateAtom);

  const handleClick = () => {
    const { event, context } = generateLandingPageBlockTracking({
      searchParams,
      userId,
      formState,
      ctaType: 'button',
      ctaWording: ctaText,
      ctaUrl,
    });
    trackCustomEvent({ event, context });
  };

  return (
    <Button
      Component={Link}
      href={ctaUrl}
      variant="contained"
      className={className}
      onClick={handleClick}
    >
      {ctaText}
    </Button>
  );
};
